export default {
  locales: [
    {
      code: 'en-GB',
      name: 'English',
      englishName: 'English',
      translations: require('./i18n/en-GB.json')
    },
    {
      code: 'ar-SA',
      english: 'عربى',
      englishName: 'Arabic',
      translations: require('./i18n/ar-SA.json'),
      rtl: true
    }
  ]
};
